export const CUSTOM_REPORT_GLOBAL_PATH = "/report";

export const getCustomReportSourcePath = ({ campaignID } = {}) => {
  const id = String(campaignID || "").trim();
  if (id) {
    return `/ads-campaign-statistics?campaignID=${encodeURIComponent(id)}`;
  }
  return CUSTOM_REPORT_GLOBAL_PATH;
};
